import * as moment from "moment";

export function createRange(start: number, end: number, step: number): number[] {
    return Array(Math.ceil((end - start) / step)).fill(start).map((x, y) => x + y * step);
}

export function randomNumber(min: number, max: number, exceptValue: number): number {
    const num = Math.floor(Math.random() * (max - min + 1)) + min;
    return (num === exceptValue) ? randomNumber(min, max, exceptValue) : num;
}

export function roundToBottom(v: number) {
    return (v >= 0 ? Math.floor(Math.abs(v)) : -1 * Math.ceil(Math.abs(v)));
}

export function roundToTop(v: number) {
    return (v >= 0 ? 1 : -1) * Math.ceil(Math.abs(v));
}

export function roundAwayFromZero(value: number, decimals: number = 0) {
    const factor = Math.pow(10, decimals);
    const scaled = value * factor;
    const rounded = (scaled > 0)
        ? Math.floor(scaled + 0.5)
        : Math.ceil(scaled - 0.5);
    return rounded / factor;
}

export function mean(arr: number[]) {
    return arr.reduce((acc, num) => acc + num, 0) / arr.length;
}

export function meanBy(arr: any[], selector: (item: any) => number) {
    if (arr.length === 0)
        return null;

    return arr.reduce((acc, item) => acc + selector(item), 0) / arr.length;
}

export function getDateRange(firstDate: string, lastDate: string) {
    if (moment.parseZone(firstDate, 'YYYY-MM-DD').isSame(moment.parseZone(lastDate, 'YYYY-MM-DD'), 'day'))
        return [lastDate];
    let date = moment.parseZone(firstDate);
    const dates = [date.format('YYYY-MM-DD')];
    do {
        date = moment.parseZone(date).add(1, 'day');
        dates.push(date.format('YYYY-MM-DD'));
    } while (date.isBefore(moment.parseZone(lastDate), 'day'));
    return dates;
}

export function truncate(num, places) {
    return Math.trunc(num * Math.pow(10, places)) / Math.pow(10, places);
}
